/** Opções de risco quando riscoTp ainda não foi carregada do banco. */
export const PROD_RISCO_FALLBACK = [
  { value: 0, label: 'Realizado', abrev: 'Realizado' },
  { value: 1, label: 'Risco baixo', abrev: 'Baixo' },
  { value: 2, label: 'Risco médio', abrev: 'Médio' },
  { value: 3, label: 'Risco alto', abrev: 'Alto' },
  { value: 4, label: 'Risco não avaliado', abrev: 'Não avaliado' },
  { value: 5, label: 'Risco relacionado a cliente', abrev: 'Cliente' },
  { value: 6, label: 'Risco relacionado a órgão público', abrev: 'Órgão' },
]

export function mapRiscoTpRows(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [...PROD_RISCO_FALLBACK]
  return rows
    .slice()
    .sort((a, b) => Number(a.riscoTp_id) - Number(b.riscoTp_id))
    .map((r) => ({
      value: Number(r.riscoTp_id),
      label: String(r.riscoTp_nome ?? ''),
      abrev: String(r.riscoTp_abrev ?? r.riscoTp_nome ?? ''),
    }))
}

export function riscoTpOptionForId(options, id) {
  if (id == null || id === '') return null
  const opts = options && options.length ? options : PROD_RISCO_FALLBACK
  return opts.find((o) => Number(o.value) === Number(id)) || null
}
